module.exports = __webpack_public_path__ + "img/subscription2.e877f99.png";